import React, { useState, memo } from "react";
import Box from "@mui/material/Box";

import { ToggleButton } from "../../../../components";

import { useAppDispatch } from "../../../../store/hooks";
import { DISCOUNTS } from "../../../../constants";
import { updateLookupThunk } from "../../../../features/productAnalyzer/productAnalyzer.thunk";

import { useStyles } from "./index.styles";

const Discounts: React.FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const [selected, setSelected] = useState<string[]>([]);

  const handleToggleClick = (item: string) => {
    const index = selected.indexOf(item);
    const updated =
      index === -1 ? [...selected, item] : selected.filter((v) => v !== item);
    const totalDiscount = updated.reduce((sum: number, item: string) => {
      if (item === "3 for 2") {
        return sum + 33.34;
      } else {
        return sum + parseFloat(item);
      }
    }, 0);
    dispatch(updateLookupThunk({ totalDiscount }));
    setSelected(updated);
  };

  return (
    <Box className={classes.root}>
      {DISCOUNTS?.map((item: string, index: number) => (
        <ToggleButton
          key={item}
          value={item}
          selected={selected.indexOf(item) !== -1}
          onClick={() => handleToggleClick(item)}
        >
          {item}
        </ToggleButton>
      ))}
    </Box>
  );
};

export default memo(Discounts);
